import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Big } from 'foundations-components/transitional/components/Big';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SnippetPopoverError = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(H5, {
    marginBlockEnd: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'RichTextLib.snippet.title.insert'
    })
  }), /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    align: "center",
    marginBlockStart: "1000",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "errors/general",
      width: "30%",
      marginBlockEnd: "300"
    }), /*#__PURE__*/_jsx(Big, {
      marginBlockEnd: "500",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'RichTextLib.snippet.error'
      })
    })]
  })]
});
export default SnippetPopoverError;